import React, { useState, useEffect } from 'react';
import { acceptInvite, rejectInvite, recallInvite, fetchNews } from '../utils/api';
import { getDateFormat } from '../utils/date';
import { mapErrorMessage } from '../utils/errorMapping';
import { formatDate } from '../utils/date';
import { getRoleClassName } from '../utils/roles';
import UserInviteCard from './UserInviteCard';
import SchoolInviteCard from './SchoolInviteCard';
import Calendar from './Calendar';
import News from './News';
import './Dashboard.css';
import './_UserTiles.css';

const Dashboard = ({ dashboardData, fetchDashboard }) => {
    const [error, setError] = useState('');
    const [news, setNews] = useState([]);

    const [dateFormat, setDateFormat] = useState(getDateFormat());

    const loadNews = async () => {
        try {
            const newsData = await fetchNews();
            setNews(newsData.data);
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    useEffect(() => {
        const handleDateFormatChange = () => {
            setDateFormat(getDateFormat());
        };

        window.addEventListener('dateFormatChanged', handleDateFormatChange);

        return () => {
            window.removeEventListener('dateFormatChanged', handleDateFormatChange);
        };
    }, []);

    useEffect(() => {
        loadNews();
    }, []);

    const handleAccept = async (inviteId) => {
        try {
            await acceptInvite(inviteId);
            if(fetchDashboard) fetchDashboard();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    const handleReject = async (inviteId) => {
        try {
            await rejectInvite(inviteId);
            if(fetchDashboard) fetchDashboard();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    const handleRecall = async (inviteId) => {
        try {
            await recallInvite(inviteId);
            if(fetchDashboard) fetchDashboard();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="dashboard-container">
            <div className="dashboard-header">
                {dashboardData && <h1>{dashboardData.school.name}</h1>}
            </div>
            <div className="content-area">
                {error && <p className="error">{error}</p>}
                {dashboardData ? (
                    <>
                        <div className="dashboard-main-content">
                            <div className="school-info-card">
                                <p><strong>SEVP Code:</strong> {dashboardData.school.sevp_code}</p>
                                <p><strong>Active Students:</strong> {dashboardData.school.student_count} / {dashboardData.school.student_limit}</p>
                                <p><strong>Staff:</strong> {dashboardData.school.staff_count} / {dashboardData.school.user_limit}</p>
                                <p><strong>Next Payment:</strong> {formatDate(dashboardData.school.payment_date)}</p>
                                {dashboardData.roles && dashboardData.roles.length > 0 && (
                                    <div className="roles-container">
                                        {dashboardData.roles.map(role => (
                                            <div key={role.id} className={`role-tile ${getRoleClassName(role.name)}`}>{role.name}</div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <Calendar />
                        </div>

                        <div className="invites-block-dashboard">
                            <div className="invites-block-dashboard-invites">
                            {dashboardData.user_invites && dashboardData.user_invites.length > 0 && (
                                <div className="invites-section">
                                    <h3>Your Invites</h3>
                                    <div className="invites-container">
                                        {dashboardData.user_invites.map(invite => (
                                            <UserInviteCard key={invite.id} invite={invite} onAccept={handleAccept} onReject={handleReject} />
                                        ))}
                                    </div>
                                </div>
                            )}

                            {dashboardData.school_invites && dashboardData.school_invites.length > 0 && (
                                <div className="invites-section">
                                    <h3>School Invites</h3>
                                    <div className="invites-container">
                                        {dashboardData.school_invites.map(invite => (
                                            <SchoolInviteCard key={invite.id} invite={invite} onRecall={handleRecall} />
                                        ))}
                                    </div>
                                </div>
                            )}
                            </div>

                            <News news={news} onNewsDeleted={loadNews} onNewsCreated={loadNews} />
                        </div>
                    </>
                ) : (
                    <p>Loading dashboard...</p>
                )}
            </div>
        </div>
    );
};

export default Dashboard;